export default __webpack_public_path__ + "static/media/filter-icon.7c19f7f7.svg";